module.exports = __webpack_public_path__ + "static/media/YAMP.4b6efc65.svg";